<template>
  <div class="root-box">
    <el-row class="condition">
      <el-form size="small" :inline="true">
        <el-form-item label="开始时间：">
          <el-date-picker v-model="param.startTime" type="datetime" placeholder="选择开始时间"
            value-format="yyyy-MM-dd HH:mm:ss" :default-time="'00:00:00'" style="width: 180px" clearable />
        </el-form-item>
        <el-form-item label="结束时间：">
          <el-date-picker v-model="param.endTime" type="datetime" placeholder="选择结束时间"
            value-format="yyyy-MM-dd HH:mm:ss" :default-time="'23:59:59'" style="width: 180px" clearable />
        </el-form-item>
        <el-form-item label="充电类型：">
          <el-select v-model="param.isSuperCharge" placeholder="请选择" clearable style="width: 100px">
            <el-option label="快充" :value="true" />
            <el-option label="慢充" :value="false" />
          </el-select>
        </el-form-item>
        <el-form-item label="司机：">
          <driver-selector v-model="param.driverIds" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query()">查询</el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button type="success" icon="el-icon-map-location" @click="openMapMode">地图模式</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <div class="table">
      <el-table ref="chargingTable" :data="list" stripe max-height="600" style="width: 100%" show-summary
        :summary-method="getSummaries" @row-click="handleRowClick">
        <el-table-column label="序号" type="index" width="50" :index="indexMethod" />
        <el-table-column prop="driverNo" label="司机编号" width="90" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.driverNo || '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="vehicleNo" label="车牌号" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.vehicleNo || '—' }}
          </template>
        </el-table-column>
        <el-table-column prop="vehicleModel" label="车型" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.vehicleModel || '—' }}
          </template>
        </el-table-column>
        <el-table-column label="满电续航" width="90">
          <template slot-scope="scope">
            {{ scope.row.totalDrivingRange != null ? scope.row.totalDrivingRange + 'km' : '—' }}
          </template>
        </el-table-column>
        <el-table-column label="电池容量" width="90">
          <template slot-scope="scope">
            {{ scope.row.batteryCapacity != null ? scope.row.batteryCapacity + 'kWh' : '—' }}
          </template>
        </el-table-column>

        <el-table-column label="时间" width="200">
          <template slot-scope="scope">
            {{ scope.row.startTime | dateFormat('MM月dd日') }} &nbsp;
            {{ scope.row.startTime | dateFormat('hh:mm') }}
            ~
            {{ scope.row.endTime | dateFormat('hh:mm') }}
          </template>
        </el-table-column>

        <el-table-column label="电量" width="120">
          <template slot-scope="scope">
            {{ scope.row.startSoc != null ? scope.row.startSoc + '%' : '—' }}
            ~
            {{ scope.row.endSoc != null ? scope.row.endSoc + '%' : '—' }}
          </template>
        </el-table-column>
        <el-table-column label="续航" width="150">
          <template slot-scope="scope">
            {{ formatRange(scope.row.startSoc, scope.row.totalDrivingRange) }}
            ~
            {{ formatRange(scope.row.endSoc, scope.row.totalDrivingRange) }}
          </template>
        </el-table-column>


        <el-table-column label="充电时长" width="120" sortable prop="totalChargingMinutes">
          <template slot-scope="scope">
            {{ scope.row.totalChargingMinutes != null ? scope.row.totalChargingMinutes + '分钟' : '—' }}
          </template>
        </el-table-column>
        <el-table-column label="充电量" width="160" sortable prop="chargingCapacity">
          <template slot-scope="scope">
            {{ scope.row.chargingCapacity != null ? scope.row.chargingCapacity + '%' : '—' }}
            <span v-if="scope.row.chargingBatteryCapacity != null">（{{ scope.row.chargingBatteryCapacity |
              numFormat(2) }}度）</span>
          </template>
        </el-table-column>

        <el-table-column label="充电类型" width="100" sortable prop="avgCur">
          <template slot-scope="scope">
            <el-tag :type="scope.row.superCharge ? 'success' : 'info'" size="small">
              {{ scope.row.superCharge ? '快充' : '慢充' }}

              <span v-if="scope.row.avgCur != null">
                {{ scope.row.avgCur | numFormat(2) }}A
              </span>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="充电地点" min-width="140" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.endChargePosition || scope.row.startChargePosition" class="charge-address-link"
              @click.stop="showRecordOnMap(scope.row)">
              {{ scope.row.endChargePosition ? scope.row.endChargePosition.name : scope.row.startChargePosition.name }}
            </span>
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page">
      <el-pagination background :current-page="currentPage" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper" :total="total" @current-change="handleCurrentChange"
        @size-change="handlePageSizeChange" />
    </div>

    <charging-record-charge-detail-modal ref="chargeDetailModal" />
    <charging-record-map-modal ref="mapModal" />
  </div>
</template>

<script>
import { ParamUtil } from "@/util";
import { listVehicleCharging } from "@/api";
import ChargingRecordChargeDetailModal from "@/components/ChargingRecordChargeDetailModal";
import ChargingRecordMapModal from "./ChargingRecordMapModal";

export default {
  name: "ChargingRecord",
  components: {
    ChargingRecordChargeDetailModal,
    ChargingRecordMapModal
  },
  data() {
    return {
      param: {
        startTime: null,
        endTime: null,
        isSuperCharge: null,
        driverIds: []
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 20
    };
  },
  created() {
    this.query();
  },
  methods: {
    query(page = 1) {
      const paramCopy = {
        startTime: this.param.startTime,
        endTime: this.param.endTime,
        isSuperCharge: this.param.isSuperCharge,
        driverIds: this.param.driverIds && this.param.driverIds.length ? this.param.driverIds : undefined
      };
      const req = {
        page: { current: page, size: this.pageSize },
        param: ParamUtil.filterEmptyData(paramCopy)
      };
      listVehicleCharging(req).then((res) => {
        const data = res.data || {};
        this.list = data.records || [];
        this.total = data.total || 0;
        this.currentPage = data.current != null ? data.current : page;
      });
    },
    indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    getSummaries({ columns, data }) {
      const sums = [];
      columns.forEach((col, index) => {
        if (index === 0) {
          sums.push("合计");
          return;
        }
        if (col.property === "totalChargingMinutes" || col.label === "充电时长") {
          const total = data.reduce((acc, row) => acc + (row.totalChargingMinutes != null ? row.totalChargingMinutes : 0), 0);
          sums.push(total ? this.formatDuration(total) : "—");
          return;
        }
        if (col.property === "chargingCapacity" || col.label === "充电量") {
          const total = data.reduce((acc, row) => acc + (row.chargingBatteryCapacity != null ? row.chargingBatteryCapacity : 0), 0);
          sums.push(total ? (total.toFixed(2) + "度") : "—");
          return;
        }
        sums.push("");
      });
      return sums;
    },
    formatDuration(minutes) {
      if (minutes == null || minutes < 0) return "—";
      const h = Math.floor(minutes / 60);
      const m = minutes % 60;
      if (h > 0) return `${h}时${m}分`;
      return `${minutes}分钟`;
    },
    handleCurrentChange(page) {
      this.query(page);
    },
    handlePageSizeChange(val) {
      this.pageSize = val;
      this.query(1);
    },
    handleRowClick(row) {
      this.$refs.chargeDetailModal.open(row);
    },
    formatRange(soc, totalDrivingRange) {
      if (soc == null || totalDrivingRange == null) return "—";
      const range = Math.round((totalDrivingRange * soc) / 100);
      return range + "km";
    },
    getChargeLocation(row) {
      const start = row.startChargePosition && row.startChargePosition.name ? row.startChargePosition.name : "";
      const end = row.endChargePosition && row.endChargePosition.name ? row.endChargePosition.name : "";
      if (start || end) return start || end;
      return "—";
    },
    showRecordOnMap(row) {
      const hasPosition =
        (row.endChargePosition && row.endChargePosition.lat && row.endChargePosition.lng) ||
        (row.startChargePosition && row.startChargePosition.lat && row.startChargePosition.lng);
      if (!hasPosition) {
        this.$message.info("该记录无地址信息");
        return;
      }
      this.$refs.mapModal.open([row]);
    },
    openMapMode() {
      if (!this.list.length) {
        this.$message.warning("请先查询充电记录");
        return;
      }
      const withLocation = this.list.filter((r) => {
        const end = r.endChargePosition && r.endChargePosition.lng && r.endChargePosition.lat;
        const start = r.startChargePosition && r.startChargePosition.lng && r.startChargePosition.lat;
        return end || start;
      });
      if (!withLocation.length) {
        this.$message.warning("当前查询结果中暂无带坐标的充电地点，无法展示地图");
        return;
      }
      this.$refs.mapModal.open(this.list);
    }
  }
};
</script>

<style scoped>
.root-box {
  padding: 20px;
}

.condition {
  background: #fff;
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
}

.table {
  background: #fff;
  padding: 0 16px 16px;
  border-radius: 4px;
}

.table>>>.el-table__row {
  cursor: pointer;
}

.charge-address-link {
  color: #409eff;
  cursor: pointer;
}

.charge-address-link:hover {
  text-decoration: underline;
}

.page {
  margin-top: 16px;
  text-align: right;
}
</style>
